import MuiDialog from '@mui/material/Dialog';
import {
  type ComponentPropsWithoutRef,
  type ComponentRef,
  forwardRef,
} from 'react';
import {
  SaveShortcutBoundary,
  type SaveShortcutStrategy,
} from '@src/shared/ui/SaveShortcutScope';

type DialogProps = ComponentPropsWithoutRef<typeof MuiDialog> & {
  shortcutBoundary?: boolean;
  shortcutStrategy?: SaveShortcutStrategy;
};
type DialogRef = ComponentRef<typeof MuiDialog>;

const Dialog = forwardRef<DialogRef, DialogProps>(
  (
    { open, shortcutBoundary = true, shortcutStrategy = 'active', ...props },
    ref,
  ) => {
    const dialog = <MuiDialog ref={ref} open={open} {...props} />;

    if (!shortcutBoundary) {
      return dialog;
    }

    return (
      <SaveShortcutBoundary
        active={open}
        priority="modal"
        strategy={shortcutStrategy}
      >
        {dialog}
      </SaveShortcutBoundary>
    );
  },
);
Dialog.displayName = 'Dialog';
export default Dialog;
